'use client'

import React, { useContext } from 'react'

import { SectionThemeContext } from '../../../contexts/SectionTheme.context'

import { Container } from '../../atoms/GridSystem'

import * as S from './Iframe.styles'

interface IframeProps {
  sectionId: string
  url: string
  iframeLabel: string
  height?: number
}

const Iframe = ({ sectionId, url, iframeLabel, height = 500 }: IframeProps) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  return (
    <S.Iframe colorScheme={selectedColorScheme} as="section" id={sectionId}>
      <Container>
        <iframe title={iframeLabel} src={url} height={height} loading="lazy" />
      </Container>
    </S.Iframe>
  )
}

export default Iframe
